import { ContaReceber } from '../Entity/ContaReceber';
import { FindManyReq } from '../Entity/TypeormTypes';
import { openFileFromBlob } from '../helper';
import {
  DadosContaReceberBaixar,
  DadosLinkPagamento,
  DadosListagemContasReceberCliente,
  ParametrosGerarQRCode,
  ParamsKeyContaReceber
} from '../types/ContaReceberTypes';
import { ResCobrancaPixImediata } from '../types/SicoobTypes';
import api from './apiEdCliente';

const PREFIX = 'api';
const ROUTE = 'edcliente/contaReceber';

class ApiContaReceber {
  async getMany(query: FindManyReq<ContaReceber>) {
    try {
      const res = await api.post<DadosListagemContasReceberCliente[]>(`/${PREFIX}/${ROUTE}/get`, {
        query
      });
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async count(query: FindManyReq<ContaReceber>) {
    try {
      const res = await api.post<number>(`/${PREFIX}/${ROUTE}/count`, { query });

      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async gerarQrCodePix(parametros: ParametrosGerarQRCode) {
    try {
      const res = await api.post<ResCobrancaPixImediata>(`/${PREFIX}/${ROUTE}/gerarQrCodePix`, {
        parametros
      });
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async consultarCobrancaImediata(txid: string, codigoEmpresa: string, codigoBanco: string) {
    try {
      const res = await api.get<ResCobrancaPixImediata>(
        `/${PREFIX}/${ROUTE}/consultarCobrancaPix?txid=${txid}&codigoEmpresa=${codigoEmpresa}&codigoBanco=${codigoBanco}`
      );
      return res.data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async baixarContaReceber(contaReceber: DadosContaReceberBaixar) {
    try {
      const res = await api.post<{ message: string }>(
        `/${PREFIX}/${ROUTE}/baixarContaReceber`,
        { contaReceber },
        { timeout: 3000000 }
      );

      const data = res.data;
      return data.message;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async getTotalDebito(codigoCliente: string) {
    try {
      const res = await api.get<number>(
        `/${PREFIX}/${ROUTE}/getTotalDebito?codigoCliente=${codigoCliente}`
      );
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async getTotalDebitosEdcliente() {
    try {
      const res = await api.get<{
        totalDebitosVencidos: number;
        totalDebitosAVencer: number;
      }>(`/${PREFIX}/${ROUTE}/getTotalDebitosEdcliente`);
      const data = res.data;
      console.log();
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async gerarReciboBaixa(params: ParamsKeyContaReceber) {
    try {
      const res = await api.post(
        `/${PREFIX}/${ROUTE}/gerarReciboBaixa`,
        { params },
        { timeout: 3000000, responseType: 'arraybuffer', headers: { Accept: 'application/pdf' } }
      );

      const blob = new Blob([res.data], { type: 'application/pdf' });
      await openFileFromBlob(blob, 'recibo.pdf', 'application/pdf');
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async gerarBoleto(params: ParamsKeyContaReceber) {
    try {
      const res = await api.post(
        `/${PREFIX}/${ROUTE}/gerarBoleto`,
        { params },
        { timeout: 3000000, responseType: 'arraybuffer', headers: { Accept: 'application/pdf' } }
      );

      const blob = new Blob([res.data], { type: 'application/pdf' });
      await openFileFromBlob(blob, 'boleto.pdf', 'application/pdf');
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async getDadosLinkPagamento(id: string) {
    try {
      const res = await api.get<DadosLinkPagamento>(
        `/${PREFIX}/${ROUTE}/getDadosLinkPagamento?id=${id}`
      );
      return res.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async baixarBoletoSeExistir(params: {
    codigoEmpresa: string;
    codigoCliente: string;
    codigoFinanceira: string;
    codigoFatura: string;
  }) {
    try {
      const res = await api.post(`/${PREFIX}/${ROUTE}/baixarBoletoSeExistir`, params);

      return res.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }
}

const apiContaReceber = new ApiContaReceber();
export default apiContaReceber;
